import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragIndicator } from '@mui/icons-material';
import { Box, Chip, IconButton, Typography } from '@mui/material';

import { DreConfigConfiguracoesDelete } from 'pages/financeiro/dre/configuracao/components/configuracoes/DreConfigConfiguracoesDelete';
import { DreConfigConfiguracoesEdit } from 'pages/financeiro/dre/configuracao/components/configuracoes/DreConfigConfiguracoesEdit';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigConfiguracoesItem({ configuracao }: { configuracao: DreConfiguracao }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: `configuracao-${configuracao.idDreMercadologicaConfiguracao}`,
    });

    return (
        <Chip
            size="small"
            ref={setNodeRef}
            sx={{
                transition,
                'padding': 0,
                'opacity': isDragging ? 0.4 : 1,
                'zIndex': isDragging ? 10 : 'auto',
                'transform': CSS.Transform.toString(transform),
                'color': configuracao.color.text,
                'backgroundColor': configuracao.color.background,
                'borderWidth': 1,
                'borderColor': configuracao.color.text,
                'borderStyle': isDragging ? 'dashed' : 'solid',
                '& > .MuiChip-label': {
                    paddingRight: 0.5,
                },
            }}
            label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography sx={{ fontSize: 12, marginRight: 0.5 }}>{configuracao.dsNomeExibicao}</Typography>

                    <DreConfigConfiguracoesDelete configuracao={configuracao} />

                    <DreConfigConfiguracoesEdit configuracao={configuracao} />

                    <IconButton
                        sx={{
                            width: 20,
                            height: 20,
                            cursor: isDragging ? 'grabbing' : 'grab',
                            color: configuracao.color.text,
                        }}
                        {...listeners}
                        {...attributes}
                    >
                        <DragIndicator fontSize="small" />
                    </IconButton>
                </Box>
            }
        />
    );
}
